/**
 * Copyright 2016-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {
    REPOSITORIES_LOADED,
    SET_REPOSITORIES
} from '../actions/hybrid';

const defaultState = {};

export default function hybrid(state = defaultState, action) {
    switch (action.type) {
        case REPOSITORIES_LOADED: {
            return {...state, repositories: action.repositories};
        }
        case SET_REPOSITORIES: {
            return {...state, repositories: action.repositories};
        }
        default:
            return state;
    }
}
